import Board from './Board'

function Game() {
  return <Board />
}

export default Game
